import { Link } from 'react-router-dom';
import styles from './AuthForm.module.scss';

interface AuthFooterLinkProps {
  to: string;
  label: string;
}

export function AuthFooterLink({ to, label }: AuthFooterLinkProps) {
  return (
    <div className={styles.footer}>
      <Link to={to}>{label}</Link>
    </div>
  );
}
